export default function useCarrierTranslations() {
  const safetyRatings = {
    "N": "No Rating",
    "S": "Satisfactory",
    "U": "Unsatisfactory",
    "C": "Conditional"
  };

  const highwayStatuses = {
    "": "Blank",
    "N": "Needs to onboard",
    "O": "Onboarded",
    "D": "Do not dispatch"
  };

  const safetyRatingsOptions = [
    {
      name: "Blank",
      value: "NULL"
    },
    {
      name: "None",
      value: "N"
    },
    {
      name: "Satisfactory",
      value: "S"
    },
    {
      name: "Unsatisfactory",
      value: "U"
    },
    {
      name: "Conditional",
      value: "C"
    }
  ];

  const certificationOptions = [
    {
      name: "Blank",
      value: "NULL"
    },
    {
      name: "Onboarded",
      value: "O"
    },
    {
      name: "Needs to onboard",
      value: "N"
    },
    {
      name: "Do not dispatch",
      value: "D"
    }
  ]; 

  const trailerAccessoriesOptions = [
    {
      name: "Bulkhead",
      value: "eq_op_bulkhead"
    },
    {
      name: "Container On Flat",
      value: "eq_op_container_flat"
    },
    {
      name: "Double Drop",
      value: "eq_op_double_drop"
    },
    {
      name: "Downloadable",
      value: "eq_op_downloadable_tru"
    },
    {
      name: "Food Grade",
      value: "eq_op_food_grade"
    },
    {
      name: "Heated",
      value: "eq_op_heated"
    },
    {
      name: "High Cube",
      value: "eq_op_high_cube"
    },
    {
      name: "Lift Gate",
      value: "eq_op_lift_gate"
    },
    {
      name: "Reefer Straight Truck",
      value: "eq_op_refrig_straight"
    },
    {
      name: "Rgn",
      value: "eq_op_rgn"
    },
    {
      name: "Roll Up",
      value: "eq_op_roll_up"
    },
    {
      name: "Standard Height",
      value: "eq_op_standard_height"
    },
    {
      name: "Step Deck",
      value: "eq_op_step_deck"
    },
    {
      name: "Swing Doors",
      value: "eq_op_swing_doors"
    },
    {
      name: "Trailer On Flat",
      value: "eq_op_trailer_flat"
    },
    {
      name: "Vented Trailer",
      value: "eq_op_vent_trailer"
    },
    {
      name: "Wood Floor",
      value: "eq_op_wood_floor"
    }
  ];

  const serviceTypesOptions = [
    {
      name: "Drayage",
      value: "drayage"
    },
    {
      name: "Drop Trailer",
      value: "drop_trailer_yes"
    },
    {
      name: "Evening Pickup",
      value: "evening_pu_del"
    },
    {
      name: "Hazmat",
      value: "hazmat_yes"
    },
    {
      name: "Intermodal",
      value: "intermodal"
    },
    {
      name: "Ltl",
      value: "ltl"
    },
    {
      name: "Power Only",
      value: "power_only_yes"
    },
    {
      name: "Private Fleet",
      value: "private_fleet"
    },
    {
      name: "Teams",
      value: "teams_yes"
    },
    {
      name: "Warehouse",
      value: "warehouse"
    }
  ];

  const cargoTypesOptions = [
    {
      name: "Agricultural Supplies",
      value: "cargo_agri_farm"
    },
    {
      name: "Beer",
      value: "cargo_beer"
    },
    {
      name: "Beverages",
      value: "cargo_beverages"
    },
    {
      name: "Building Materials",
      value: "cargo_building_mat"
    },
    {
      name: "Chemicals",
      value: "cargo_chemicals"
    },
    {
      name: "Coal",
      value: "cargo_coal_coke"
    },
    {
      name: "Commodities Dry Bulk",
      value: "cargo_commod_dry"
    },
    {
      name: "Construction",
      value: "cargo_construction"
    },
    {
      name: "Drive Tow",
      value: "cargo_drive_tow"
    },
    {
      name: "Electronics",
      value: "cargo_electronics"
    },
    {
      name: "Floor Loaded",
      value: "cargo_floor_loaded"
    },
    {
      name: "Garbage",
      value: "cargo_garbage"
    },
    {
      name: "Grain Feed",
      value: "cargo_grain_feed"
    },
    {
      name: "General Freight",
      value: "cargo_gen_freight"
    },
    {
      name: "Household Goods",
      value: "cargo_household"
    },
    {
      name: "Ice Cream",
      value: "cargo_ice_cream"
    },
    {
      name: "Intermodal Cargo",
      value: "cargo_intermodal"
    },
    {
      name: "Liquid Or Gas",
      value: "cargo_liquids_gas"
    },
    {
      name: "Liquor",
      value: "cargo_liquor"
    },
    {
      name: "Livestock",
      value: "cargo_livestock"
    },
    {
      name: "Lumber",
      value: "cargo_logs_lumber"
    },
    {
      name: "Machinery",
      value: "cargo_machinery"
    },
    {
      name: "Meat",
      value: "cargo_meat"
    },
    {
      name: "Metal",
      value: "cargo_metal"
    },
    {
      name: "Mobile Homes",
      value: "cargo_mobile_homes"
    },
    {
      name: "Oil Field Equipment",
      value: "cargo_oil_equip"
    },
    {
      name: "Other",
      value: "cargo_other"
    },
    {
      name: "Paper Products",
      value: "cargo_paper_prod"
    },
    {
      name: "Paper Rolls",
      value: "cargo_paper_rolls"
    },
    {
      name: "Passengers",
      value: "cargo_passengers"
    },
    {
      name: "Pork",
      value: "cargo_pork"
    },
    {
      name: "Produce",
      value: "cargo_produce"
    },
    {
      name: "Reefer Food",
      value: "cargo_reefer_food"
    },
    {
      name: "Seafood",
      value: "cargo_seafood"
    },
    {
      name: "Tobacco",
      value: "cargo_tobacco"
    },
    {
      name: "Us Mail",
      value: "cargo_us_mail"
    },
    {
      name: "Utilities",
      value: "cargo_utilities"
    },
    {
      name: "Vehicles",
      value: "cargo_vehicles"
    },
    {
      name: "Water",
      value: "cargo_water_well"
    }
  ];

  const roles = {
    "isDispatch": "Dispatch",
    "isAfterhours": "After Hours",
    "isBilling": "Billing",
    "isDriver": "Driver",
    "isOsd": "OS&D",
    "isOwner": "Owner",
    "isOther": "Other"
  };

  return {
    safetyRatings,
    highwayStatuses,
    safetyRatingsOptions,
    certificationOptions,
    trailerAccessoriesOptions,
    serviceTypesOptions,
    cargoTypesOptions,
    roles
  };
}